import React from 'react'
import { withRouter } from 'react-router-dom'

const ClientGuid = ({ data, business, history }) => (
  <div>
    <div style={{ borderRadius: '10px 10px 0 0' }} className='ibox-title'>
      <h5>Access Code</h5>
    </div>
    <div className='ibox-content text-center'>
      <div>
        <span className='bg-success p-xs' style={{ cursor: 'default', fontSize: '14px' }}>
          {/*<Link to={`/access-codes/${business}`} style={{ color: 'white' }}>*/}
          {data || 'N/A'}
          {/*</Link>*/}
        </span>
      </div>
    </div>
  </div>
)

export default withRouter(ClientGuid)
